import axios from 'axios';

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  withCredentials: true,
});

axiosServices.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response && error.response.status;
    const isLoginRequest = (error.config && error.config.url || '').includes('/auth/login');

    // A 401 on an authenticated request means the session expired or the
    // token is invalid — bounce back to login instead of leaving the user
    // stuck on a screen where every action fails with a raw "jwt expired".
    if (status === 401 && !isLoginRequest && localStorage.getItem('accessToken')) {
      localStorage.removeItem('accessToken');
      sessionStorage.clear();
      if (!window.location.pathname.startsWith('/auth/login')) {
        window.location.replace('/auth/login');
      }
    }

    return Promise.reject((error.response && error.response.data) || 'Error en el servidor');
  },
);

export default axiosServices;